import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import { Transition } from 'react-transition-group';
import "./LoadingOverlay.css";

var renderOverlay = function renderOverlay(state, inverse, label) {
  if (state === 'exited') {
    return false;
  }

  var loadingClasses = classNames('LoadingOverlay', 'fade', {
    in: [state === 'entered'],
    'LoadingOverlay--inverse': inverse
  });
  return /*#__PURE__*/React.createElement("div", {
    role: "status",
    className: loadingClasses
  }, /*#__PURE__*/React.createElement("ul", {
    "aria-hidden": true,
    className: "LoadingOverlay__ul"
  }, /*#__PURE__*/React.createElement("li", {
    className: "LoadingOverlay__li LoadingOverlay__li--1 bg-brand"
  }), /*#__PURE__*/React.createElement("li", {
    className: "LoadingOverlay__li LoadingOverlay__li--2 bg-brand"
  }), /*#__PURE__*/React.createElement("li", {
    className: "LoadingOverlay__li LoadingOverlay__li--3 bg-brand"
  }), /*#__PURE__*/React.createElement("li", {
    className: "LoadingOverlay__li LoadingOverlay__li--4 bg-brand"
  })), label && /*#__PURE__*/React.createElement("div", {
    className: "LoadingOverlay__label"
  }, label));
};

function LoadingOverlay(_ref) {
  var inverse = _ref.inverse,
      label = _ref.label,
      loading = _ref.loading,
      transition = _ref.transition,
      transitionAppear = _ref.transitionAppear,
      onLoadingStop = _ref.onLoadingStop;
  return /*#__PURE__*/React.createElement(Transition, {
    appear: transitionAppear && transition,
    in: loading,
    timeout: 500,
    onExited: onLoadingStop,
    enter: transition,
    exit: transition,
    unmountOnExit: true
  }, function (state) {
    return renderOverlay(state, inverse, label);
  });
}

LoadingOverlay.propTypes = {
  /** Flag for displaying inverse color scheme */
  inverse: PropTypes.bool,

  /** Label to display below the loading dots */
  label: PropTypes.node,

  /** Flag for displaying LoadingOverlay */
  loading: PropTypes.bool,

  /** Optional event handler to fire after a LoadingOverlay has been dismissed */
  onLoadingStop: PropTypes.func,

  /** Flag for enabling transitions */
  transition: PropTypes.bool,

  /** Option Flag for enabling transitions when the component appears */
  transitionAppear: PropTypes.bool
};
LoadingOverlay.defaultProps = {
  transition: true,
  transitionAppear: true,
  loading: true,
  onLoadingStop:
  /* istanbul ignore next */
  function onLoadingStop() {},
  inverse: false
};
export default LoadingOverlay;
//# sourceMappingURL=LoadingOverlay.js.map